import moment from "moment";
export const get = (path, object, defaultValue = null) =>
  path.reduce((xs, x) => (xs && xs.hasOwnProperty(x) ? xs[x] : defaultValue), object);

export const getFilename = media => {
  const sectorName = get(["sector", "sector_label"], media, "SECTEUR");
  const pdcName = get(["salepoint", "pdc_label"], media, "PDC");
  const salepoint = media.salepoint || {};
  const pdcZipCode = get(["salepoint", "adresse", "cp"], media);
  const city1 = get(["salepoint", "adresse", "ville"], media);
  const city2 = get(["salepoint", "city"], media);
  const city = city1 || city2;
  const pdcZipCodeAlt = get(["salepoint", "zip_code"], media);
  const zip_code = pdcZipCode || pdcZipCodeAlt;
  const pdcDepartmentNb = zip_code
    ? zip_code.toString().slice(0, -3) //version hors pharma
    : salepoint.department; // version pharma}}
  const date = get(["created_at"], media, "DATE");
  return `${sectorName}, ${pdcName}, ${city}, ${pdcDepartmentNb ? `${pdcDepartmentNb}, ` : ""} ${moment(date).format(
    "YYYY-MM-DD"
  )}.png`;
};

export function forceDownload(url, fileName) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
}

export const getFilenameEcosystem = (media, index) => {
  const sectorName = get(["sector", "sector_label"], media, "SECTEUR");
  const pdcName = get(["salepoint", "pdc_label"], media, "PDC");
  const salepoint = media.salepoint || {};
  const pdcZipCode = get(["salepoint", "adresse", "cp"], media);
  const city1 = get(["salepoint", "adresse", "ville"], media);
  const city2 = get(["salepoint", "city"], media);
  const city = city1 || city2;
  const pdcZipCodeAlt = get(["salepoint", "zip_code"], media);
  const zip_code = pdcZipCode || pdcZipCodeAlt;
  const pdcDepartmentNb = zip_code
    ? zip_code.toString().slice(0, -3) //version hors pharma
    : salepoint.department; // version pharma}}
  const date = get(["created_at"], media, "DATE");
  const code_sap = get(["salepoint", "code_sap"], media, "");
  const location = get(["location", "label"], media, "");
  const statement = get(["statement", "label"], media, "");
  return (
    `${sectorName}, ${pdcName}, ${city}, ${pdcDepartmentNb ? `${pdcDepartmentNb}, ` : ""} ${moment(date).format(
      "YYYY-MM-DD"
    )}`.replaceAll("/", "-") +
    "/" +
    `${index}-${code_sap ? `${code_sap} - ` : ""}  ${location} - ${statement}`.replaceAll("/", "-") +
    ".png"
  );
};



// WEBPACK FOOTER //
// src/containers/activite/phototeque/photo.utils.js